'use client';

import { type CSSProperties } from 'react';
import { ToastContainer } from 'react-toastify';

export type TPosition =
  | 'bottom-left'
  | 'bottom-right'
  | 'top-left'
  | 'top-right'
  | 'bottom-center'
  | 'top-center';

type TToastProviderProps = {
  position: TPosition;
};

export const ToastProvider = ({ position }: TToastProviderProps) => {
  return (
    <ToastContainer
      rtl={false}
      className='!z-[9999]'
      style={
        {
          '--toastify-color-progress-error': '#f7525f',
          '--toastify-color-progress-success': '#089981',
        } as CSSProperties
      }
      toastClassName={() =>
        `flex relative bg-modalBg text-text max-h-[200px] items-center justify-center min-h-[49px] w-screen xs:w-full md:min-w-[300px] md:w-fit shadow-[0_2px_6px_rgba(0,0,0,0.2)] px-1 pb-[5px] pt-[2px] text-xs rounded-none xs:rounded-md justify-center overflow-hidden cursor-pointer my-0 md:my-2`
      }
      position={position}
      autoClose={5000}
      closeOnClick
    />
  );
};
